import { UserRole } from './core';
import { Features } from './core/features';

const Roles = {
  NAVBAR_MENU: [
    {
      action: Features.CALENDAR,
      roles: [UserRole.admin, UserRole.manager, UserRole.readonly],
    },
    {
      action: Features.CONTACTS,
      roles: [UserRole.admin, UserRole.manager, UserRole.register],
    },
    {
      action: Features.STATISTICS,
      roles: [UserRole.admin, UserRole.manager],
    },
    //
    {
      action: Features.EXCLUSIONS,
      roles: [UserRole.admin, UserRole.manager, UserRole.register],
    },
    {
      action: Features.EXPORT,
      roles: [UserRole.admin],
    },
  ],

  /*
    Os dois atalhos do topo do menu levam a filas de trabalho: abrir um contato
    de hoje ou uma resposta recebida existe para registrar a interação. O perfil
    somente leitura não registra nada, então a fila só lhe ofereceria um caminho
    que termina numa tela sem ação -- por isso ele não está nas listas abaixo.
  */
  NAVBAR_BADGE: [
    {
      action: Features.CONTACT_TODAY,
      roles: [UserRole.admin, UserRole.manager, UserRole.register],
    },
    {
      action: Features.DELIVERED_RESPONSE_TODAY,
      roles: [UserRole.admin, UserRole.manager, UserRole.register],
    },
  ],

  EXCLUSION_LIST_VIEW_ALL: [UserRole.admin, UserRole.manager],
};

const getNavBarBadgeRolesByAction = (action: string) =>
  Roles.NAVBAR_BADGE.find((i: any) => i.action === action)?.roles ?? [];

const getNavBarMenuRolesByAction = (action: string) =>
  Roles.NAVBAR_MENU.find((i: any) => i.action === action)?.roles ?? [];

export { getNavBarBadgeRolesByAction, getNavBarMenuRolesByAction, Roles };
